import { EditablePriceScale } from '../../api/asset/assetApiTypes';

/**
 * The body for `PUT /pricecategory/:id/pricescales`, built from the object
 * page's rows.
 *
 * Extracted from `AssetDetailPage.handleSave` so it can be tested, because the
 * bug it fixes is invisible by inspection. `updatePriceScales` matches an
 * incoming row to an existing one on its **whole scope** — days, full-day flag,
 * duration, start and end — and archives every existing row it cannot match.
 * So a payload that merely omits a field does not leave that field alone: it
 * archives the row and creates a scope-less copy in its place.
 *
 * The object page edits only the price, so it must send the rest back
 * untouched. Before this it dropped `startTime`, `endTime` and
 * `additionalDaysPrice` — 25 rows in production carry a time window (KGSt tool
 * rental, Bundeskanzleramt) and two carry an additional-days price (kolula
 * KEY), and any price edit on those objects silently flattened them.
 *
 * `null` rather than `undefined` on purpose: the row is being described in
 * full, and an absent key would read as "no opinion" to a future caller.
 *
 * `customerClassId` joined the scope in #1808 and is here for exactly the
 * reason the paragraph above describes: omit it and every class-specific rate
 * is archived the next time anyone edits a price, because the row the backend
 * matched against no longer looks like the row that was sent.
 */
export const toPriceScalePayload = (scales: EditablePriceScale[]) =>
    scales.map((s) => ({
        durationInMinutes: s.durationInMinutes,
        price: s.price,
        days: s.days ?? null,
        isFullDay: s.isFullDay,
        startTime: s.startTime ?? null,
        endTime: s.endTime ?? null,
        additionalDaysPrice: s.additionalDaysPrice ?? null,
        customerClassId: s.customerClassId ?? null,
    }));
